export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/ed3e1222f5d7e466f1889a4510f1de5c.svg";